import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { Compare } from "./pages";

export const CompareRouter = [
  <Route
    path="/compare"
    element={
      <ProtectedRoute roles={["Any"]}>
        <Compare />
      </ProtectedRoute>
    }
  />,
];
